<style>
.center {
  margin: 20px 0 0 20px;
}
</style>

<template>
  <div class="app-container">
    <ut-form inline class="center">
      <ut-form-item label="应用">
        <ut-select v-model="selected1" filterable clearable	:filter-method='filter'>
          <ut-option v-for="item in appSearchOptions||appOptions" :value="item.appId" :key="item.appId" :label="item.appId"></ut-option>
        </ut-select>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="search">查询</ut-button>
      </ut-form-item>
    </ut-form>

    <ut-table :source="dataSource" border>
      <ut-table-column title="报警Key" key="alarmKey" index="alarmKey" />
      <ut-table-column title="应用ID" key="appId" index="appId" width="200"/>
      <ut-table-column title="报警时间" key="alarmTime" index="alarmTime" :formatter="formatDate" />
      <ut-table-column title="报警内容" key="content" index="content" width="500" inline-template>
        <div>
          <ut-tooltip :content="row.content" placement="top-start">
            <p>{{ row.content.slice(0, 60) }}...</p>
          </ut-tooltip>
          <ut-button size="small" type="primary" v-copy="row.content" v-copy:success="success" v-copy:error="error">点我复制</ut-button>
        </div>
      </ut-table-column>
    </ut-table>
    <ut-pagination
      :style="{ marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '20px' }"
      :total="pageInfo.totalCount"
      :current="pageNo"
      @change="changePager"
      :page-size="20"
    ></ut-pagination>
  </div>
</template>

<script lang="babel">
export default {
  data() {
    return {
      alarmKey:'',
      appOptions: [],
      appSearchOptions: null,
      selected1: "",
      pageInfo: {
        totalCount: 0
      },
      pageNo: 1,
      dataSource: []
    };
  },
  computed: {

  },
  methods: {
    filter (val) {
      const data = []
      this.appOptions.map(item => {
          if (item.appId.toLowerCase().indexOf(val) !== -1 || item.appName.toLowerCase().indexOf(val) !== -1) {
            data.push(item)
          }
      })
      if (data.length) {
        this.appSearchOptions = data;
      } else {
        this.appSearchOptions = [];
      }
    },
    formatDate(value){
      var date = new Date(value.alarmTime);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = (date.getDate() < 10 ? '0'+ date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

      return Y+M+D+h+m+s;
    },
    success(){
      this.$message.info('复制成功');
    },
    error(){
      this.$message.error('复制失败');
    },
    goAdd() {
      this.$router.push({ path: "/alarms/add" });
    },
    deleteRow(idx, row) {
      console.log("delete this.dataSource.length idx ["+this.dataSource.length+"] row ["+idx+"]")
      if(this.dataSource.length == 1 && this.pageNo != undefined){
        this.pageNo = 0;
        this.pageInfo.totalCount = 1;
      }
      this.$http({
        method: "post",
        url: "alarms/" + row.id + "/remove.htm"
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          var sendData = {}

          if(this.selected1 != undefined && this.selected1 != ""){
            sendData.appId = this.selected1;
          }

          if(this.pageNo == undefined){
            sendData.pageNo = 0;
          }else{
            sendData.pageNo = this.pageNo;
          }

          console.log(sendData)
          var sendJson = JSON.stringify(sendData);

          this.$http({
            method: "post",
            url: "alarms/query.htm",
            data: sendJson
          })
            .then(response => {
              //这里使用了ES6的语法
              console.log(response); //请求成功返回的数据
              this.dataSource = response.data.dataList;
            })
            .catch(error => {
              console.log(error); //请求失败返回的数据
            });
            })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    formatLevel(level) {
      switch (level) {
        case 0: {
          return "2";
        }
        case 1: {
          return "primary";
        }
        case 2: {
          return "success";
        }
        case 3: {
          return "warning";
        }
        case 4: {
          return "danger";
        }
      }
    },
    changePager(page) {

      var sendData = {}
      if(page == 0){
        return false;
      }
      if(this.selected1 != undefined && this.selected1 != ""){
        sendData.appId = this.selected1;
      }

      if(this.selected1 != undefined && this.selected1 != ""){
        sendData.appId = this.selected1;
      }
      sendData.pageNo = page;

      console.log(sendData)
      var sendJson = JSON.stringify(sendData);

      this.$http({
        method: "post",
        url: "alarms/query.htm",
        data: sendJson
      })
        .then(response => {
          this.$message.info(`当前切换到第${page}页`);
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          this.pageNo = page;
          this.dataSource = response.data.dataList;
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    search(){
      var sendData = {}

      if(this.selected1 != undefined && this.selected1 != ""){
        sendData.appId = this.selected1;
      }

      console.log(sendData)
      var sendJson = JSON.stringify(sendData);
      console.log(sendJson)
      this.$http({
            method: "post",
            url: "alarms/query.htm",
            data: sendJson
          })
          .then(response => {
            //这里使用了ES6的语法
            console.log(response); //请求成功返回的数据
            this.dataSource = response.data.dataList;
            this.pageInfo.totalCount = response.data.totalCount;
            this.pageNo = response.data.totalPageCount > 0 ? 1:0;
            this.$message.info(`当前切换到第${this.pageNo}页`);
          })
          .catch(error => {
            console.log(error); //请求失败返回的数据
          });
    }
  },
  created() {
    this.$http({
      method: "post",
      url: "alarms/query.htm",
      data: "{}"
    })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response); //请求成功返回的数据
        this.dataSource = response.data.dataList;
        this.pageInfo.totalCount = response.data.totalCount;
      })
      .catch(error => {
        console.log(error); //请求失败返回的数据
      });

    this.$http({
      method: "post",
      url: "apps/list.htm",
      data: "{}"
    })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response.data.length); //请求成功返回的数据
        this.appOptions = response.data;
      })
      .catch(error => {
        console.log(error); //请求失败返回的数据
      });
  }
};
</script>
